import NZCommonSearchNav from "./Common/NZCommonSearchNav";

const NZSearchNavBarHandler = ({ activeNav, setActiveNav }) => {
  //add a validation for each tenant if the search nav will become tenant specific
  return <NZCommonSearchNav setActiveNav={setActiveNav}></NZCommonSearchNav>;
};

export default NZSearchNavBarHandler;
